export default __webpack_public_path__ + "static/cto-banner-img-90a90f260dadfbb1cc728c1bff954f15.png";